export const SET_USER_AUTH = 'user/SET_USER_AUTH';
export const CHG_FIELD = 'user/changeField';
export const REFRESH_FORM = 'user/refreshForm';
export const SET_LOADER = 'user/isLoading';
export const SET_AUTHENTICATED = 'user/setAuthenticated';
export const UPDATE_CREDENTIALS = 'user/setCredentials';
export const SET_PUBLIC_AUTHENTICATED = 'user/setPublicAuthenticated';